import React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import MAppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import {inject, observer} from "mobx-react";
import AccessTime from "@material-ui/icons/AccessTime";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import ReelEditor from "../pages/ReelEditor";
import {withStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import rem from "../utils/rem";
import AppBarMenu from "./AppBarMenu";
import ExperienceLogoSelector from "./ExperienceLogoSelector";

const Spacer = styled.div`
  && {
    flex-grow: 1;
  }
`;

const SavingProgress = withStyles({
  root: {
    width: "1.5rem !important",
    height: "1.5rem !important",
    margin: "0 12px"
  }
})(CircularProgress);

const StyledButton = withStyles(theme => ({
  root: {
    color: "#9e9e9e",
    textTransform: "none",
    margin: rem(5, "16px"),
    paddingLeft: rem(12, "16px"),
    paddingRight: rem(12, "16px"),
    fontWeight: 400,
    fontSize: rem(13, "16px")
  }
}))(Button);

const NavItem = React.forwardRef((props, ref) => (
    <StyledButton ref={ref} component={Link} size="small" {...props} />
));

const NavDivider = withStyles({
  root: {
    alignSelf: "stretch",
    height: "auto",
    marginLeft: 0,
    marginRight: 12
  }
})(props => <Divider orientation="vertical" flexItem {...props} />);

class AppBar extends React.Component {
  logout = async () => {
    this.props.authStore.logout();
  };

  render() {
    const {reelStore, authStore} = this.props;

    return (
      <MAppBar
        position="static"
        color="inherit"
        elevation={0}
        style={{ borderBottom: "1px solid #EEE" }}
      >
        <Toolbar>
          <ExperienceLogoSelector />
          {authStore.isAuthenticated && <NavDivider />}
          {authStore.isAuthenticated && <NavItem to="/">Search</NavItem>}
          {authStore.isAuthenticated && authStore.canViewAllRules && (
            <NavItem to="/rules">Rules</NavItem>
          )}
          {authStore.isAuthenticated && (
            <AppBarMenu
              label={"Clips"}
              component={StyledButton}
              items={[
                {
                  component: NavItem,
                  to: "/clips",
                  label: "My Clips"
                },
                {
                  component: NavItem,
                  to: "/custom-clips",
                  label: "Custom Game Clip"
                },
                ...(authStore.canAccessAdhocClipping ? [{
                  component: NavItem,
                  to: "/custom-clips/adhoc",
                  label: "Custom Ad Hoc Clip"
                }] : [])
              ]}
            />
          )}
          <Spacer />
          {reelStore.isCreatingClip ? (
            <SavingProgress />
          ) : (
            <IconButton
              style={{ marginRight: "1rem" }}
              onClick={() => reelStore.setDialogOpen(true)}
            >
              <Badge
                color="secondary"
                badgeContent={reelStore.reelClips.length}
                invisible={reelStore.reelClips.length === 0}
              >
                <AccessTime />
              </Badge>
            </IconButton>
          )}
          <Button onClick={this.logout}>Logout</Button>
        </Toolbar>
        <ReelEditor />
      </MAppBar>
    );
  }
}

export default inject("authStore", "reelStore")(observer(AppBar));



// WEBPACK FOOTER //
// ./src/components/AppBar.js